import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";

export const policy = type => {
  document.title = 'トランクルームをお探しなら『ハローストレージ』【公式】｜このサイトについて';
  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "このサイトについて" }])}
      
      <div className="policy">
        <h2 id="contentsHead">このサイトについて</h2>
        <p className="basicTxt01">
          本WEBサイトは、エリアリンク株式会社（以下、当社）が運営しております。ご利用になる前に、以下をよくお読みいただき、これらを同意された場合のみ、本WEBサイトをご利用ください。
        </p>
        <div className="box02">
          <h3>著作権について</h3>
          <div className="box02Txt">
            <p>
              本WEBサイトに掲載されている内容の著作権は、原則として当社に属しています。当社に無断で転用・複製等することはできません。
            </p>
          </div>
        </div>
        <div className="box02">
          <h3>免責事項について</h3>
          <div className="box02Txt">
            <p>
              当社は、本WEBサイトの内容について、細心の注意を払っております。
              <br />
              しかし、本WEBサイトの内容の正確性、信頼性、有用性等に関しましては、保証いたしません。本WEBサイトの情報、サービス等は、あくまでブラウザで閲覧されたそのままの状態で提供されます。
            </p>
            <p>
              本WEBサイトのご利用により損害が生じたとしても、当社は責任を負いませんので、ご自身の責任においてご利用下さい。同様に、本WEBサイトのサービスの停止、欠陥及びそれらが原因となり発生した損害についても、当社は責任を負いません。
              <br />
              また、本WEBサイトにリンクが設定されている他のサイトの利用によって生じた損害につきましても、責任を負いません。
            </p>
          </div>
        </div>
        <div className="box02">
          <h3>このサイトへのリンクについて</h3>
          <div className="box02Txt">
            <p>
              原則として、公序良俗に反するWEBサイト以外に、制限はございません。また、リンクの報告も必要ありません。
              <br />
              しかし、本WEBサイトへのリンクが原因とした、如何なる損害についても責任を負いません。
            </p>
          </div>
        </div>
        <div className="box02">
          <h3>個人情報について</h3>
          <div className="box02Txt">
            <p>
              本WEBサイトでは、サービスの提供やサービスの向上・改善などのため、お客様からお名前、Eメールアドレス等の個人情報を収集させていただく場合がございます。
              収集した個人情報を、本WEBサイトのサービスの提供及び改善する目的の範囲内でのみ利用させていただきます。
            </p>
            <p>
              ただし、あらかじめ当社との間で秘密保持契約を締結している当社業務提携先・業務委託先・関係会社に必要な限度において開示する場合がございます。しかし、司法又は行政機関、法令により開示を求められた場合は、この限りではありません。
            </p>
            <p>
              また、個人情報は個人を特定できないよう統計的に処理した上で、データとして第三者に提供することがございます。
              お客様が提供された個人情報の照会・修正・削除をご希望される場合には、お申し出いただければ、できる限り速やかに対応させていただきます。
            </p>
          </div>
        </div>
        <div className="box02">
          <h3>利用環境について</h3>
          <div className="box02Txt">
            <p>
              本WEBサイトは、以下のブラウザ環境でのご利用を推奨しております。
            </p>
            <table
              border="0"
              cellspacing="0"
              cellpadding="0"
              className="tableBasic"
            >
              <tr>
                <th>ブラウザ</th>
              </tr>
              <tr>
                <td>Internet Explorer11, Firefox 28.0</td>
              </tr>
            </table>
            <p className="mt10">
              また、本WEBサイトは制御にJavaScriptを使用しております。ブラウザの設定でJavaScriptが無効になっている場合は、閲覧や機能に問題が生じる場合がございます。
            </p>
            <p>
              コンテンツによっては、閲覧のために以下のプラグインを必要とする場合がございます。
            </p>
            <table
              border="0"
              cellspacing="0"
              cellpadding="0"
              className="tableBasic"
            >
              <tr>
                <th>SWFファイル</th>
                <th>PDFファイル</th>
              </tr>
              <tr>
                <td>
                  <a
                    href="http://www.macromedia.com/jp/shockwave/download/?P1_Prod_Version=ShockwaveFlash&Lang=Japanese"
                    target="_blank"
                  >
                    <img
                      src="resource/img/static/policy/get_flash_player.gif"
                      width="88"
                      height="31"
                      alt="Get Macromedia Flash Player"
                      title="Get Macromedia Flash Player"
                    />
                  </a>
                  <br />
                  <a
                    href="http://www.macromedia.com/jp/shockwave/download/?P1_Prod_Version=ShockwaveFlash&Lang=Japanese"
                    target="_blank"
                  >
                    Macromedia Flash Player
                  </a>
                </td>
                <td>
                  <a
                    href="http://www.adobe.co.jp/products/acrobat/readstep2.html"
                    target="_blank"
                  >
                    <img
                      src="resource/img/static/policy/getacro.gif"
                      width="88"
                      height="31"
                      alt="Get Adobe Reader"
                      title="Get Adobe Reader"
                    />
                  </a>
                  <br />
                  <a
                    href="http://www.adobe.co.jp/products/acrobat/readstep2.html"
                    target="_blank"
                  >
                    Adobe Acrobat Reader
                  </a>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/static/policy.jsx